import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class MeetingMembers extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterSunday1'>
      <img className='logo' src={logo}></img>
      <div><Link to='/'>Home</Link></div>
      <h3>MARINE MARTIAL ARTS</h3>
      <br />
        <div><Link to='/register'>1. AAT 2471</Link></div>
        <br />
        <div><Link to='/register'>2. AAT 7864</Link></div>
        <br />
        <div><Link to='/register'>3. AAT 7759</Link></div>
        <br />
        <div><Link to='/register'>4. AAT 7761</Link></div>
        <br />
        <div><Link to='/register'>5. AAT 7832</Link></div>
        <br />
        <div><Link to='/register'>6. AAT 7833</Link></div>
        <br />
        <div><Link to='/register'>7. AAT 7822</Link></div>
        <br />
        <div><Link to='/register'>8. AAT 7892</Link></div>
        <br />
        <div><Link to='/register'>9. AAT 7923</Link></div>
        <br />
        <div><Link to='/register'>10. AAT 7910</Link></div>
        <br />
        <div><Link to='/register'>11. AAT 7884</Link></div>
        <br />
        <div><Link to='/register'>12. AAT 7926</Link></div>
        <br />
        <div><Link to='/register'>13. AAT 7896</Link></div>
        <br />
        <div><Link to='/register'>14. AAT 7897</Link></div>
        <br />
        <div><Link to='/register'>15. AAT 7924</Link></div>
        <br />
        <div><Link to='/register'>16. AAT 7925</Link></div>
        <br />
        <div><Link to='/register'>17. AAT 7783</Link></div>
        <br />
        <div><Link to='/register'>18. AAT 7973</Link></div>
        <br />
        <div><Link to='/register'>19. AAT 7972</Link></div>
        <br />
        <div><Link to='/register'>20. AAT 7961</Link></div>
        <br />
        <div><Link to='/register'>21. AAT 7779</Link></div>
        <br />
        <div><Link to='/register'>22. AAT 7887</Link></div>
        <br />
        <div><Link to='/register'>23. AAT 7908</Link></div>
        <br />
        <div><Link to='/register'>24. AAT 7891</Link></div>
        <br />
        <div><Link to='/register'>25. AAT 8003</Link></div>
        <br />
        <div><Link to='/register'>26. AAT 8004</Link></div>
        <br />
        <div><Link to='/register'>23. AAT 8005</Link></div>
        <br />
        <div><Link to='/register'>24. AAT 8006</Link></div>
        <br />
        <h3>TUKSOM AIKIDO</h3>
        <div><Link to='/register'>1. AAT 5471</Link></div>
        <br />
        <div><Link to='/register'>2. AAT 5483</Link></div>
        <br />
        <div><Link to='/register'>3. AAT 5995</Link></div>
        <br />
        <div><Link to='/register'>4. AAT 6514</Link></div>
        <br />
        <div><Link to='/register'>5. AAT 7229</Link></div>
        <br />
        <div><Link to='/register'>6. AAT 7369</Link></div>
        <br />
        <div><Link to='/register'>7. AAT 7731</Link></div>
        <br />
        <div><Link to='/register'>8. AAT 7749</Link></div>
        <br />
        <div><Link to='/register'>9. AAT 7847</Link></div>
        <br />
        <div><Link to='/register'>10. AAT 7870</Link></div>
        <br />
        <div><Link to='/register'>11. AAT 7918</Link></div>
        <br />
        <div><Link to='/register'>12. AAT 7942</Link></div>
        <br />
        <h3>WONGWIANYAI DOJO</h3>
        <div><Link to='/register'>1. AAT 0961</Link></div>
        <br />
        <div><Link to='/register'>2. AAT 7541</Link></div>
        <br />
        <div><Link to='/register'>3. AAT 7518</Link></div>
        <br />
        <div><Link to='/register'>4. AAT 7645</Link></div>
        <br />
        <div><Link to='/register'>5. AAT 8007</Link></div>
        <br />
        <div><Link to='/register'>6. AAT 8008</Link></div>
        <br />
        <div><Link to='/register'>7. AAT 8009</Link></div>
        <br />
        <h3>NORTHERN AIKIDO</h3>
        <div><Link to='/register'>1. AAT 7934 </Link></div>
        <br />
        <div><Link to='/register'>2. AAT 7935</Link></div>
        <br />
        <div><Link to='/register'>3. AAT 7937</Link></div>
        <br />
        <div><Link to='/register'>4. AAT 7957</Link></div>
        <br />
        <div><Link to='/register'>5. AAT 7958</Link></div>
        <br />
        <div><Link to='/register'>6. AAT 7959</Link></div>
        <br />
        <div><Link to='/register'>7. AAT 7882</Link></div>
        <br />
        <div><Link to='/register'>8. AAT 7856</Link></div>
        <br />
        <div><Link to='/register'>9. AAT 7857</Link></div>
        <br />
        <div><Link to='/register'>10. AAT 7439</Link></div>
        <br />
        <div><Link to='/register'>11. AAT 7268</Link></div>
        <br />
        <div><Link to='/register'>12. AAT 7593</Link></div>
        <br />
        <div><Link to='/register'>13. AAT 7859</Link></div>
        <br />
        <div><Link to='/register'>14. AAT 7872</Link></div>
        <br />
        <div><Link to='/register'>15. AAT 7144</Link></div>
        <br />
        <div><Link to='/register'>16. AAT 7678</Link></div>
        <br />
        <div><Link to='/register'>17. AAT 7968</Link></div>
        <br />
        <div><Link to='/register'>18. AAT 7971</Link></div>
        <br />
        <div><Link to='/register'>19. AAT 7969</Link></div>
        <br />
        <div><Link to='/register'>20. AAT 7967</Link></div>
        <br />
        <div><Link to='/register'>21. AAT 7970</Link></div>
        <br />
        <div><Link to='/register'>22. AAT 7966</Link></div>
        <br />
        <div><Link to='/register'>23. AAT 7713</Link></div>
        <br />
        <div><Link to='/register'>24. AAT 7691</Link></div>
        <br />
        <div><Link to='/register'>25. AAT 7381</Link></div>
        <br />
        <h3>KORAT DOJO</h3>
        <div><Link to='/register'>1. AAT 6032</Link></div>
        <br />
        <div><Link to='/register'>2. AAT 7801</Link></div>
        <br />
        <div><Link to='/register'>3. AAT 7804</Link></div>
        <br />
        <div><Link to='/register'>4. AAT 7805</Link></div>
        <br />
        <div><Link to='/register'>5. AAT 7823</Link></div>
        <br />
        <div><Link to='/register'>6. AAT 7974</Link></div>
        <br />
        <h3>CHULALONGKORN UNIVERSITY AIKIDO CLUB</h3>
        <div><Link to='/register'>1. AAT 2339</Link></div>
        <br />
        <div><Link to='/register'>2. AAT 5642</Link></div>
        <br />
        <div><Link to='/register'>3. AAT 6681</Link></div>
        <br />
        <div><Link to='/register'>4. AAT 7954</Link></div>
        <br />
        <div><Link to='/register'>5. AAT 7955</Link></div>
        <br />
        <div><Link to='/register'>6. AAT 8002</Link></div>
        <br />
        <h3>FORMER RENBUKAN DOJO</h3>
        <div><Link to='/register'>1. AAT 0037  MS.SUWANNEE  PAEKHAO(A)</Link></div>
        <br />
        <div><Link to='/register'>2. AAT 0580  GEN.DANAI  YUWABOON(A)</Link></div>
        <br />
        <div><Link to='/register'>3. AAT 0747  MR.KANIN  AMPAIPAN(A)</Link></div>
        <br />
        <div><Link to='/register'>4. AAT 1402  MR.NATTHAPHAT INGSAKULSOMBOON(A)</Link></div>
        <br />
        <div><Link to='/register'>5. AAT 2712  MR.WORAPOT  BENJANART(A)</Link></div>
        <br />
        <div><Link to='/register'>6. AAT 3597  MR.SOMCHAI  CHAIYACHETDUMRONGKUL(A)</Link></div>
        <br />
        <div><Link to='/register'>7. AAT 3814  MR.PISUT  KRIANGBURAPA(A)</Link></div>
        <br />
        <div><Link to='/register'>9. AAT 4360  MR.WINYU  CHAIYAWAN(A)</Link></div>
        <br />
        <div><Link to='/register'>10. AAT 5081 MR.CHAIWAT  THIRAPANTU(A)</Link></div>
        <br />
        <div><Link to='/register'>11. AAT 5623  MR.ALEXANDER  KUSHNAREV(A)</Link></div>
        <br />
        <div><Link to='/register'>13. AAT 7764  MR.SHINTARO  KON(A)</Link></div>
        <br />
        <div>
          Thailand's Aikido Association Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default MeetingMembers;
